import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { styles } from "./SkeletonCounterBoxes.style";

export interface SkeletonCounterBoxesProps {
  count?: number;
}

export const SkeletonCounterBoxes = (props: SkeletonCounterBoxesProps) => {
  const { count = 3 } = props;
  return (
    <div className={styles.root()}>
      {Array.from({ length: count }).map((_, index) => {
        const isLastItem = index === count - 1;
        return (
          <div key={`skeleton-counter-box-${index}`} className={styles.counterBox()}>
            <div className={styles.labelSection()}>
              <Skeleton height={16} />
            </div>
            <div className={styles.valueSection()}>
              <Skeleton height={48} />
            </div>
            <div className={styles.linkSection()}>{!isLastItem && <Skeleton height={16} />}</div>
          </div>
        );
      })}
    </div>
  );
};
